export default __webpack_public_path__ + "static/media/xtreme-project-1.2eb17fca.jpg";